import languageStorage     from "@/assets/localization"
import { ErrorLogService, ObjectUtil } from "@/services"

const defaultLanguageCode = "EN"

const state = {
  localizedContent: {},
  defaultContent: {}
}

const mutations = {
  SET_DEFAULT_CONTENT: function (state, defaultContent) {
    state.defaultContent = defaultContent
  },
  SET_LOCALIZED_CONTENT: function (state, localizedContent) {
    state.localizedContent = localizedContent
  }
}

const actions = {
  LOAD_LANGUAGES: ({ commit, dispatch }, languageCode) => {
    languageCode = languageCode.toString().toUpperCase()

    var defaultLanguage = languageStorage.translations.find(translation => translation.language === defaultLanguageCode)
    commit("SET_DEFAULT_CONTENT", defaultLanguage)

    var localLanguage = languageStorage.translations.find(translation => translation.language === languageCode)
    if (typeof localLanguage != "undefined") {
      commit("SET_LOCALIZED_CONTENT", localLanguage)
    } else {
      commit("SET_LOCALIZED_CONTENT", defaultLanguage)
    }
    return new Promise(function (resolve, reject) {
      resolve(true)
    })
  }
}

const getters = {
  getContentItem: (state) => (itemName) => {
    // default to English if the localized property doesn't exist
    const value = ObjectUtil.findValueByKey(state.localizedContent, itemName) || ObjectUtil.findValueByKey(state.defaultContent, itemName);

    if (typeof value != "undefined") {
      return value;
    }

    if (process.env !== "production") {
      console.warn(`Localization not found for dictionary item: ${itemName}`)
    }
    return `_${itemName}_`;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
